export default __webpack_public_path__ + "/fonts/roboto-v27-latin-ext_latin_cyrillic-ext_cyrillic-700.woff2";